import type { TileState } from '../types';
import { COLS } from './constants';

// Two-pass scoring: lock greens first, then yellows. Without the second pass,
// duplicate letters in the guess can falsely both turn yellow even when the
// answer only contains one of them.
export function evaluateGuess(guess: string, answer: string): TileState[] {
  const result: TileState[] = Array<TileState>(COLS).fill('absent');
  const remaining: (string | null)[] = answer.split('');
  for (let i = 0; i < COLS; i++) {
    if (guess[i] === answer[i]) {
      result[i] = 'correct';
      remaining[i] = null;
    }
  }
  for (let i = 0; i < COLS; i++) {
    if (result[i] === 'correct') continue;
    const ch = guess[i];
    if (ch === undefined) continue;
    const idx = remaining.indexOf(ch);
    if (idx !== -1) {
      result[i] = 'present';
      remaining[idx] = null;
    }
  }
  return result;
}
